module.exports = __webpack_public_path__ + "media/images/badge-clip-0d2980c94814229a983968a9559c2705.svg";